import Http from '../http';

const prefix = '/mailing_boss';

var softCache = [];

export const getLists = (cache = true, page = 0, perPage = 0) => {
  if (!softCache[`get-lists-${page}-${perPage}`] || !cache)
    softCache[`get-lists-${page}-${perPage}`] = Http.authApi().get(`${prefix}/get-lists?page${page}&per_page=${perPage}`);

  return softCache[`get-lists-${page}-${perPage}`];
};

export const getFields = (list) => {
  return Http.authApi().get(`${prefix}/get-fields/${list}`);
};

export const createList = (data) => {
  return Http.authApi().post(`${prefix}/create-list`, {data});
};

export const getCustomUrl = (list) => {
  return Http.authApi().get(`${prefix}/get-custom-url/${list}`);
};

export const setCustomUrl = (data, list_uid) => {
  Http.authApi().post(`${prefix}/set-custom-url`, {data, list_uid});
};

export const getUserInfoBasic = () => {
  return Http.authApi().get(`${prefix}/get-user-info-basic`);
};



// WEBPACK FOOTER //
// ./src/js/services/integrations-internas/mailingboss.js